import React from "react";

const DownArrow = ({ id, color }) => {
  return (
    <svg id={id} width="13px" height="8px" viewBox="0 0 13 8">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          transform="translate(-57.000000, -325.000000)"
          stroke={color || "#bfbbbd"}
          strokeWidth="1.5"
        >
          <polyline
            id="down-arrow"
            transform="translate(63.500000, 328.750000) rotate(180.000000) translate(-63.500000, -328.750000) "
            points="58 331.5 63.5846154 326 69 331.5"
          ></polyline>
        </g>
      </g>
    </svg>
  );
};

export default DownArrow;
